import React from "react";
import Row from "../layout/Row";
import Icon1 from "../icons/Icon";
import TextFieldBorderLess from "./TextFieldBorderLess";
import { useState } from "react";
import { Switch, useTheme } from "@mui/material";
import TextFieldSearch from "./TextFieldSearch";
import TFGPT1 from "./TFGPT1";

function SearchBarGallerie({ orgData, options, value, setValue, onAction }) {
  const theme = useTheme();

  return (
    <div className="bg-white rounded-3xl border-1 border-shadow_25 w-fit pl-3 pr-2 py-0 h-fit">
      <Row x={10} align="left" className="w-full">
        <Icon1 icon_name="search" fill={theme.palette.shadow._50}></Icon1>
        <TFGPT1
          options={options}
          placeholder="Chercher"
          inputValue={value}
          setInputValue={setValue}
          onAction={onAction}
          className="w-full"
          start_only={false}
          show_options={false}
        ></TFGPT1>
      </Row>
    </div>
  );
}

export default SearchBarGallerie;
